import React, { Context, ProviderProps } from "react";

export interface ContextProviderIfValidProps<T> extends ProviderProps<T> {
	StoreContext: Context<T>;
}

const ContextProviderIfValid = <T extends unknown>(props: ContextProviderIfValidProps<T>) => {
	const store = props.value;
	const Provider = props.StoreContext.Provider;

	return (
		<>
			{store && (
				<Provider value={store}>
					{props.children}
				</Provider>
			)}
		</>
	);
};

export default ContextProviderIfValid;